import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Valeria P.',
    detail: 'Mamá de Tomás (3)',
    text: 'Me sentía culpable cada vez que le daba el celular. Ahora tenemos un plan B real para cada tarde.'
  }, {
    name: 'Daniela O.',
    detail: 'Mamá de Joaquín (5)',
    text: 'Mi hijo me pide hacer las actividades antes que ver dibujitos. No lo podía creer.'
  }, {
    name: 'Romina C.',
    detail: 'Mamá de mellizos (4)',
    text: 'Con dos al mismo tiempo era un caos. El planner solo ya vale lo que pagué.'
  }, {
    name: 'Sofía R.',
    detail: 'Mamá de Mateo (2)',
    text: 'Antes terminábamos usando la TV después del trabajo. Ahora tenemos una alternativa real.'
  }, {
    name: 'Belén R.',
    detail: 'Mamá de Mía (2)',
    text: 'Pensé que mi hija era muy chica para esto, pero hay propuestas adaptadas a cada edad.'
  }, {
    name: 'Mariana H.',
    detail: 'Mamá de Olivia (3)',
    text: 'Lo recomendé a todas las mamás del jardín. Es lo más práctico que encontré.'
  }];
  return <section className="bg-white px-5 py-10 sm:py-12" data-id="element-166">
      <div className="max-w-3xl mx-auto" data-id="element-167">
        <div className="text-center mb-8" data-id="element-168">
          <div className="flex justify-center mb-3" data-id="element-169">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-brand-cream-300 text-brand-cream-300" data-id="element-170" />)}
          </div>
          <h2 className="font-extrabold text-3xl sm:text-4xl text-brand-ink leading-tight tracking-tight" data-id="element-171">
            Mamás que ya están{' '}
            <span className="highlight-yellow" data-id="element-172">disfrutando</span> Crecer Jugando
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-173">
          {reviews.map(review => <div key={review.name} className="bg-brand-green-50/40 rounded-2xl p-5 border border-brand-green-100/60" data-id="element-174">
              <div className="flex mb-3" data-id="element-175">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-brand-cream-300 text-brand-cream-300" data-id="element-176" />)}
              </div>
              <p className="text-slate-700 leading-relaxed text-[15px] mb-4" data-id="element-177">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-178">
                <div className="w-9 h-9 rounded-full bg-brand-green-200 flex items-center justify-center text-brand-green-700 font-bold text-sm" data-id="element-179">
                  {review.name.charAt(0)}
                </div>
                <div data-id="element-180">
                  <p className="font-bold text-sm text-brand-ink leading-tight" data-id="element-181">
                    {review.name}
                  </p>
                  <p className="text-xs text-slate-500" data-id="element-182">{review.detail}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}